<template>
  <div class="empty">
    <div class="empty-img">
      <img src="@/assets/images/empty.svg" alt="">
    </div>
    <slot name="emptyTips"></slot>
  </div>
</template>

<script>
export default {
  name: 'empty',
  props: {
    msg: String
  },
  data(){
    return{
    }
  }
}
</script>
<style scoped >
  .empty{
    margin-top: 100px;
    text-align: center;
    width: 100%;
  }

.empty .empty-img{margin-bottom: 50px;      text-align: center;}

.empty .empty-txt{
    text-align:center ;
    font-size: 14px;
    color: #222;}
</style>